import * as React from "react";
import { observer } from "mobx-react";
import { SeeTaskEventsModalStoreContext } from "../../store";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Alert from "@mui/material/Alert";

const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const SeeTaskEventsModal = observer((props) => {
  const seeTaskEventsModalStore = React.useContext(
    SeeTaskEventsModalStoreContext,
  );

  const getAlertSeverityFromEventCategory = (category) => {
    const map = {
      INFO: "info",
      WARNING: "warning",
      ERROR: "error",
      FATAL: "error",
    };

    return map[category] ?? "info";
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={MODAL_STYLE}>
          {seeTaskEventsModalStore.error.length > 0 && (
            <Alert severity="error">{seeTaskEventsModalStore.error}</Alert>
          )}
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Context</TableCell>
                <TableCell>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {seeTaskEventsModalStore.events.map((event) => (
                <TableRow key={event.id}>
                  <TableCell>{event.context}</TableCell>
                  <TableCell>
                    <Alert
                      severity={getAlertSeverityFromEventCategory(
                        event.category,
                      )}
                    >
                      {event.details}
                    </Alert>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Modal>
    </div>
  );
});
export default SeeTaskEventsModal;
